import { RefSoustypeUtilisateur } from '../../droits/models/ref-soustype-utilisateur.model';
import { Fonction } from './fonction.model';
import { Groupe } from './groupe.models';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class ContactGroupe {
    static jsonMap = {
        idContact: { key: 'idContact', optional: true },
        nom: { key: 'nom', optional: true, default: '' },
        prenom: { key: 'prenom', optional: true, default: '' },
        raisonsociale: { key: 'raisonsociale', optional: true, default: '' },
        fonction: { key: 'fonction', converter: new (ClassConverterFactory.build(Fonction))(), optional: true },
        groupes: { key: 'groupes', converter: new (ArrayClassConverterFactory.build(Groupe))(), default: () => [] },
        refSousType: { key: 'refSousType', converter: new (ClassConverterFactory.build(RefSoustypeUtilisateur))(), optional: true }
    };

    public idContact: number;
    public nom: string;
    public prenom: string;
    public raisonsociale: string;
    public fonction: Fonction;
    public groupes: Groupe[];
    public refSousType: RefSoustypeUtilisateur;
}
